<template>
  <section>
    <article
      class="aggregator-order"
      v-for="order in orders"
      v-bind:key="order.id"
    >
      <div>
        <span class="aggregator-order__date">{{ order.starts_date }}</span>
        <span class="aggregator-order__time">{{ order.starts_time }}</span>
      </div>
      <div>
        <span class="aggregator-order__term">Врач</span>
        <span class="aggregator-order__def">{{ order.employee_name }}</span>
      </div>
      <div>
        <span class="aggregator-order__term">Пациент</span>
        <span class="aggregator-order__def">{{ order.patient_name }}</span>
      </div>
      <div class="aggregator-order__buttons">
        <button
          v-if="cancelable"
          class="aggregator-order__cancel"
          type="button"
          v-on:click="showCancelDialog(order.id)"
        >Отменить</button>
        <button
          class="aggregator-order__make"
          type="button"
          v-on:click="dispatchMake(order.id)">Записать</button>
      </div>
    </article>
    <modal-dialog
      v-model="cancelDialog"
      title="Отменить и удалить запись?"
      with-cross
    >
      <div class="aggregator-order__buttons">
        <button
          class="aggregator-order__cancel negative"
          type="button"
          v-on:click="closeCancelDialog()">Нет</button>
        <button
          class="aggregator-order__cancel"
          type="button"
          v-on:click="dispatchCancel()">Да, удалить</button>
      </div>
    </modal-dialog>
  </section>
</template>

<script>
import ModalDialog from '@/components/ModalDialog.vue';

/**
 * @description Компонента списка заявок от агрегатора.
 * @type {Vue}
 */
export default {
  data() {
    return {
      /**
       * @description Состояние диалога отмены.
       * @type {boolean}
       */
      cancelDialog: false,
      /**
       * @description Идентификатор заявки с агрегатора.
       * @type {number}
       */
      selectedOrderId: 0,
    };
  },
  components: { ModalDialog },
  methods: {
    /**
     * Показать диалог отмены заявки с агрегатора
     * @param {number} orderId идентификатор заявки с агрегатора
     */
    showCancelDialog(orderId) {
      this.cancelDialog = true;
      this.selectedOrderId = orderId;
    },
    /**
     * Закрыть диалог отмены заявки с агрегатора
     */
    closeCancelDialog() {
      this.cancelDialog = false;
      this.selectedOrderId = 0;
    },
    /**
     * @description Отправить событие отмены.
     * @returns {void}
     */
    dispatchCancel() {
      this.$emit('aggregator-cancel-order', this.selectedOrderId);
      this.closeCancelDialog();
    },
    /**
     * @description Отправить событие создания.
     * @param {number} id Идентификатор заявки.
     * @returns {void}
     */
    dispatchMake(id) {
      this.$emit('aggregator-make-order', id);
    },
  },
  name: 'AggregatorOrderList',
  props: {
    /**
     * @description Может отменять заявки.
     */
    cancelable: { type: Boolean, required: true },
    /**
     * @description Заявки на прием от агрегатора.
     */
    orders: { type: Array, required: true },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.aggregator {
  &-order {
    display: flex;
    flex-direction: column;
    background-color: #ffeded;
    border: 1px solid rgba(239, 71, 76, 0.4);
    border-right: 6px solid #EF474C;
    border-radius: 4px;
    padding: 9px 11px;
    margin: 0 0 3px 0;
    &__date,
    &__time,
    &__term {
      color: #707683;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
    }
    &__def {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #192A3E;
    }
    &__term ~ &__def,
    &__date ~ &__time {
      margin-left: 1rem;
    }
    &__term:after {
      content: ":";
    }
    &__buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      margin: 15px 0 0 0;
    }
    &__cancel {
      @include buttons.btn-transparent(100%, 2rem, 1rem);
      &.modal {
        max-width: 50%;
        margin: 0 5px;
      }
      &.negative {
        border: 1px solid rgba(224, 4, 4, 0.97);
        color: rgba(224, 4, 4, 0.97);
      }
    }
    &__make {
      @include buttons.btn-blue(100%, 2rem, 1rem);
    }
  }
}
</style>
